import {
	ADMINKYCMAPPINGLIST_SUCCESS,
	ADMINKYCMAPPINGLIST_FAILED,
	RESET_ADMINKYCMAPPINGLIST,
	LOADING_ADMINKYCMAPPINGLIST,
	NETWORK_ERROR_ADMINKYCMAPPINGLIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminKycMappingList = () => {
	return { type: RESET_ADMINKYCMAPPINGLIST };
};

const adminKycMappingList = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINKYCMAPPINGLIST });
	await adminServices
		.post("getKycMappingList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminKycMappingListsuccess(res.data));
					break;
				default:
					dispatch(adminKycMappingListFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINKYCMAPPINGLIST,
				payload: err
			});
		});
};
function adminKycMappingListsuccess(data) {
	return {
		type: ADMINKYCMAPPINGLIST_SUCCESS,
		payload: data
	};
}
function adminKycMappingListFailed(data) {
	return {
		type: ADMINKYCMAPPINGLIST_FAILED,
		payload: data
	};
}

export { resetAdminKycMappingList, adminKycMappingList };
